import { ReactNode } from 'react'
import { Button } from '@systemeio/components'
import { PaletteIcon } from '@systemeio/icons'
import { useTranslation } from 'next-i18next'
import { twMerge } from 'tailwind-merge'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import useThemeEditorToggle from '../hooks/use-theme-editor-toggle'

export default function ThemeEditorButton({ className }: { className?: string }): ReactNode {
  const { t } = useTranslation()

  const { openEditor, isOpenEditor, allowedToEdit } = useThemeEditorToggle()

  if (!allowedToEdit || isOpenEditor) return null

  return (
    <Button
      variant="primary"
      title={t('themes.editor.cta.manage_themes')}
      onClick={openEditor}
      className={twMerge(
        `group flex items-center justify-center rounded-lg bg-THEME-secondary! p-2.5 text-sm font-semibold whitespace-nowrap text-THEME-block-background! transition-colors hover:bg-THEME-hover-secondary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:bg-THEME-disabled!`,
        className,
        addPublicCustomClassNamePrefix([
          'course__button',
          'course__button--primary',
          'course__button--manage-themes',
        ]),
      )}
    >
      <PaletteIcon
        aria-hidden
        className="size-5 group-hover:text-THEME-hover-header-text lg:hidden"
      />
      <span className="sr-only lg:not-sr-only">{t('themes.editor.cta.manage_themes')}</span>
    </Button>
  )
}
